import React from 'react';
import {
    TableCell,
    TableRow,
} from 'material-ui';
import StaffTranslationsTableItemActions from './StaffTranslationsTableItemActions';
import {cutLongStrings} from '../../../components/helpers/helpers';

class StaffTranslationsTableContent extends React.Component {

    render() {
        const {
            classes,
            staffMember,
            site,
            staffTranslation,
            handleClick,
            handleClickOpen,
            handleDisable,
            handleEnable,
        } = this.props;

        return (
            <TableRow hover={true}>
                <TableCell className={classes.tableCell}>{staffTranslation !== null ? staffTranslation.id : '-'}</TableCell>
                <TableCell className={classes.tableCell}>{site.id}</TableCell>
                <TableCell className={classes.tableCell}>{site.display_name}</TableCell>
                <TableCell className={classes.tableCell}>
                    {staffTranslation !== null ? staffTranslation.name + ' ' + staffTranslation.firstname : 'There are no translations for this website yet!'}
                </TableCell>
                <TableCell className={classes.tableCell}>
                    {staffTranslation !== null ? 
                        <span 
                            className="noMargin noPadding" 
                            dangerouslySetInnerHTML={{__html: cutLongStrings(staffTranslation.description)}}
                        />
                        : 'There are no translations for this website yet!'
                    }
                </TableCell>
                <StaffTranslationsTableItemActions
                    staffMember={staffMember}
                    classes={classes}
                    site={site}
                    staffTranslation={staffTranslation}
                    handleClick={handleClick}
                    handleClickOpen={handleClickOpen}
                    handleDisable={handleDisable}
                    handleEnable={handleEnable}
                />
            </TableRow>
        )
    }
}

export default StaffTranslationsTableContent;


// WEBPACK FOOTER //
// ./src/containers/staff/translations/StaffTranslationsTableItem.jsx